<h1 mat-dialog-title>Create output formula &mdash; Range</h1>
<mat-dialog-content class="dialog-body">
  <mat-form-field appearance="outline" class="form-field">
    <mat-label>Name</mat-label>
    <input matInput [formControl]="nameControl" type="text" />
  </mat-form-field>

  <div class="spawn-buttons">
    <button
      mat-stroked-button
      type="button"
      [disabled]="stillsSectionOpen"
      (click)="addStillsSection()"
    >
      <mat-icon inline="true">image</mat-icon>+ Stills
    </button>
    <button
      mat-stroked-button
      type="button"
      [disabled]="videosSectionOpen"
      (click)="addVideosSection()"
    >
      <mat-icon inline="true">movie</mat-icon>+ Videos
    </button>
  </div>

  @if (stillsSectionOpen) {
    <div class="media-section">
      <div class="media-section-header">
        <span class="media-section-title">
          <mat-icon inline="true">image</mat-icon>Stills
        </span>
        <button
          mat-icon-button
          type="button"
          title="Remove stills combo"
          (click)="removeStillsSection()"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Range convention</mat-label>
        <mat-select [formControl]="stillsConventionIdControl">
          @for (fc of rangeConventions; track fc.id) {
            <mat-option [value]="fc.id">{{ fc.name }}</mat-option>
          }
        </mat-select>
        @if (rangeConventions.length === 0) {
          <mat-hint>No range conventions exist yet. Create one in the Filename conventions tab first.</mat-hint>
        }
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Spec</mat-label>
        <mat-select [formControl]="stillsSpecIdControl">
          @for (fs of stillsFileSpecifications; track fs.id) {
            <mat-option [value]="fs.id">{{ fs.name }}</mat-option>
          }
        </mat-select>
        @if (stillsFileSpecifications.length === 0) {
          <mat-hint>No stills specs exist yet. Create one in the File specifications tab first.</mat-hint>
        }
      </mat-form-field>
    </div>
  }

  @if (videosSectionOpen) {
    <div class="media-section">
      <div class="media-section-header">
        <span class="media-section-title">
          <mat-icon inline="true">movie</mat-icon>Videos
        </span>
        <button
          mat-icon-button
          type="button"
          title="Remove videos combo"
          (click)="removeVideosSection()"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Range convention</mat-label>
        <mat-select [formControl]="videosConventionIdControl">
          @for (fc of rangeConventions; track fc.id) {
            <mat-option [value]="fc.id">{{ fc.name }}</mat-option>
          }
        </mat-select>
        @if (rangeConventions.length === 0) {
          <mat-hint>No range conventions exist yet. Create one in the Filename conventions tab first.</mat-hint>
        }
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Spec</mat-label>
        <mat-select [formControl]="videosSpecIdControl">
          @for (fs of videosFileSpecifications; track fs.id) {
            <mat-option [value]="fs.id">{{ fs.name }}</mat-option>
          }
        </mat-select>
        @if (videosFileSpecifications.length === 0) {
          <mat-hint>No videos specs exist yet. Create one in the File specifications tab first.</mat-hint>
        }
      </mat-form-field>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end" class="actions">
  <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
  <button
    mat-stroked-button
    type="button"
    color="buttonSuccess"
    [disabled]="!canCreate"
    (click)="create()"
  >
    Create
  </button>
</mat-dialog-actions>
